module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Eject-1d866c69228777476e0451329dbcb34e.svg";